export default __webpack_public_path__ + "static/media/testLogo.bfaa584b.jpg";